import { Card } from "@repo/ui";
import React from "react";
import { useParams } from "react-router-dom";

type NewsItem = {
  id: number;
  slug: string;
  title: string;
  description: string;
  cover_image: string | null;
  created_at: string;
  created_by: string | null;
};

export function NewsDetail() {
  const { slug } = useParams();
  const [item, setItem] = React.useState<NewsItem | null>(null);
  const [status, setStatus] = React.useState<"loading" | "not_found" | "ok">("loading");

  React.useEffect(() => {
    if (!slug) return;
    (async () => {
      const res = await fetch(`/api/news/${slug}`);
      const data = (await res.json()) as { status: string; data: NewsItem | null };
      if (data.status === "ok" && data.data) {
        setItem(data.data);
        setStatus("ok");
        document.title = `${data.data.title} — Lucky News`;
      } else {
        setStatus("not_found");
      }
    })();
  }, [slug]);

  if (status === "loading") return <p className="text-sm text-foreground/70">กำลังโหลด...</p>;
  if (status === "not_found")
    return <p className="text-sm text-foreground/70">ไม่พบข่าวที่คุณต้องการ</p>;

  return (
    <article className="max-w-3xl mx-auto space-y-4">
      {item?.cover_image && (
        <div className="rounded-xl overflow-hidden border border-border/60">
          <div
            className="aspect-[16/9] bg-cover bg-center"
            style={{ backgroundImage: `url(${item.cover_image})` }}
          />
        </div>
      )}
      <header>
        <div className="text-xs text-foreground/60">
          {new Date(item!.created_at).toLocaleDateString("th-TH")}
          {item?.created_by ? ` · โดย ${item.created_by}` : ""}
        </div>
        <h1 className="font-display text-3xl mt-2">{item?.title}</h1>
      </header>
      <Card className="p-4 bg-card/60 text-sm leading-relaxed whitespace-pre-line">
        {item?.description}
      </Card>
    </article>
  );
}

export default NewsDetail;
